import {
  TX_SEARCH_RESET,
  TX_SEARCH_START,
  TX_SEARCH_INVALID_TERM_HIDE,
  TX_SEARCH_INVALID_TERM_SHOW,
} from '../actions/transaction_search'
import { LOGOUT_SUCCESS } from '../actions'

export const transactionSearch = (state = { searchTerm: '', searchParameter: '', error: null }, action) => {
  switch (action.type) {
    case TX_SEARCH_START:
      return { ...state, searchTerm: action.searchTerm, searchParameter: action.searchParameter }
    case LOGOUT_SUCCESS:
    case TX_SEARCH_RESET:
      return { ...state, searchTerm: '', searchParameter: action.searchParameter, error: null }
    case TX_SEARCH_INVALID_TERM_SHOW:
      return { ...state, error: action.error }
    case TX_SEARCH_INVALID_TERM_HIDE:
      return { ...state, error: null }
    default:
      return state
  }
}
